import React from "react";
import {observer} from "mobx-react";
import {IonIcon} from "@ionic/react";
import {menuOutline} from "ionicons/icons";
import styled from "styled-components";
import {
    ISideMenuControllerViewModel
} from "../../services/side-menu/side-menu-controller.view-model.interface";

const BurgerMenuBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    font-size: 24px;
    cursor: pointer;
    
`

export const BurgerMenuComponent: React.FC<{sideMenuController: ISideMenuControllerViewModel}> = observer((props) => {
    const onClick = async () => {
        await props.sideMenuController.toggle();
    }
    return (
        <BurgerMenuBox onClick={onClick}>
            <IonIcon icon={menuOutline}/>
        </BurgerMenuBox>
    )
});